import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { CIVILISATION_ID } from '../../app/constants'
import { extractStake } from '../../utilities/extractStake'

export const PercentageDisplay = ({ total, mission, isMP, civilization }) => {
  const [display, setDisplay] = useState(0)
  const stakingStats = useSelector((state) => state.epoch)
  const userStakingStats = useSelector((state) => state.stakeInfo)

  const userEpochDetailsData = stakingStats.userEpochDetails
  const epochDetailsData = stakingStats.epochDetails

  const NFTstakeDetails = userStakingStats.userNFTStakingDetails?.find(e => 
    e?.civilization === CIVILISATION_ID[civilization] &&
    e?.mission === mission)
  const [totalValue, setTotalValue] = useState(0)
  const [value, setValue] = useState(0)

  useEffect(() => {
    if (epochDetailsData.length > 0) {
      const filteredTotalValue = epochDetailsData.find(
        (item) =>
          item.mission === mission &&
          item.civilization === CIVILISATION_ID[civilization],
      )
      const filteredValue = isMP
        ? NFTstakeDetails?.total_power || 0.00
        : userEpochDetailsData.find(
            (item) => item.epoch_stake_id === filteredTotalValue.id,
          )
      console.log('debugging values:', filteredValue, filteredTotalValue, parseFloat(filteredValue), epochDetailsData)
      setValue(
        isNaN(parseFloat(filteredValue)) ? 0 : parseFloat(filteredValue),
      )
      setTotalValue(
        filteredTotalValue
          ? isMP
            ? parseFloat(filteredTotalValue.total_power)
            : extractStake(filteredTotalValue.total_staked)
          : 0,
      )
    }
  }, [NFTstakeDetails, NFTstakeDetails?.total_power, civilization, epochDetailsData, isMP, mission, stakingStats, userEpochDetailsData])

  useEffect(() => {
    if (!total) {
      
      console.log('debugging values 2:', value, totalValue)
      
      setDisplay((value * 100) / totalValue || 0)}
    else {
      if (epochDetailsData.length > 0) {
        const totals = epochDetailsData.filter(
          (e) => e.civilization === CIVILISATION_ID[civilization],
        )

        setDisplay(
          (totalValue * 100) /
            Math.max(...totals.map((e) => extractStake(e.total_staked))),
        )
      }
      
    }
  }, [civilization, epochDetailsData, total, totalValue, value])

  return (
    <div
      style={{ backgroundSize: `${display}%` }}
      className={classNames(
        display < 5 ? 'text-gold' : 'text-brown',
        'bg-gradient-to-r border border-gold py-1.5 2xl:py-2 to-gold from-lightGold rounded bg-no-repeat pl-3',
      )}
    >
      {total
        ? `${totalValue.toFixed(2) || 0.00} ${isMP ? 'MP' : ''}`
        : `${value.toFixed(2) || 0.00} ${isMP ? 'MP' : `${display}%`}`}
    </div>
  )
}
